import createPaymentAchCheckStatus from '../../../../../helpers/tables/createPaymentAchCheckStatus';

export const createAchCheckLabels = (payment) => {
  return [
    {
      title: 'ACH Status',
      isVisible: () => payment?.source === 'ACH',
      value: () => {
        return createPaymentAchCheckStatus(payment);
      },
    },
    {
      title: 'Check Status',
      isVisible: () => payment?.source === 'Check',
      value: () => {
        return createPaymentAchCheckStatus(payment);
      },
    },
  ];
};
